import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";

import api from "../../../api/api";
import { getCaseId, getClientId } from "../../../Utils/helper";
import "./panelchecklist.css";
// import VerifiedIcon from "../../../assets/verified_yes.png";
import { useChecklistWebSocket } from "../../../Hooks/useChecklistWebSocket";
import CircularGauge from "../../CheckLists/new-checklist/CircularGauge";

const PanelChecklistTreatment = ({ entity_id, page_id, type, setTopMargin, setTopMarginShow }) => {
  const caseId = getCaseId();
  const clientId = getClientId();
  const [show, setShow] = useState(false);
  const [data, setData] = useState(null);
  const [percentage, setPercentage] = useState(null);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [panelName, setPanelName] = useState("");
  const pages = useSelector((state) => state?.allPages?.allPages);

  const colors = [
    "#07013b",
    "#07013b",
    "#06013e",
    "#060242",
    "#060246",
    "#06034a",
    "#05044d",
    "#050451",
    "#050555",
    "#040558",
    "#04065c",
    "#040760",
    "#040764",
    "#030867",
    "#03086b",
    "#03096f",
    "#030a73",
    "#020a76",
    "#020b7a",
    "#020b7e",
    "#010c81",
    "#010d85",
    "#010d89",
    "#010e8d",
    "#000e90",
    "#000f94",
    "#090e8e",
    "#120e88",
    "#1b0d82",
    "#240d7c",
    "#2d0c76",
    "#360b70",
    "#3f0b6b",
    "#480a65",
    "#510a5f",
    "#5a0959",
    "#630853",
    "#6c084d",
    "#740747",
    "#7d0741",
    "#86063b",
    "#8f0535",
    "#98052f",
    "#a10429",
    "#aa0424",
    "#b3031e",
    "#bc0218",
    "#c50212",
    "#ce010c",
    "#d70106",
    "#e00000",
    "#de0801",
    "#dc0f02",
    "#da1702",
    "#d81e03",
    "#d62604",
    "#d42d05",
    "#d23506",
    "#d03c06",
    "#ce4407",
    "#cc4c08",
    "#ca5309",
    "#c85b0a",
    "#c7620a",
    "#c56a0b",
    "#c3710c",
    "#c1790d",
    "#bf810e",
    "#bd880e",
    "#bb900f",
    "#b99710",
    "#b79f11",
    "#b5a612",
    "#b3ae12",
    "#b1b513",
    "#afbd14",
    "#a8bb13",
    "#a1b812",
    "#9ab612",
    "#93b311",
    "#8cb110",
    "#85ae0f",
    "#7eac0e",
    "#77a90e",
    "#70a70d",
    "#69a50c",
    "#62a20b",
    "#5ba00a",
    "#549d0a",
    "#4d9b09",
    "#469808",
    "#3f9607",
    "#389406",
    "#319106",
    "#2a8f05",
    "#238c04",
    "#1c8a03",
    "#158702",
    "#0e8502",
    "#078201",
    "#008000",
  ];

  const getColorFromPercentage = (percentage) => {
    percentage = Math.min(Math.max(percentage, 0), 100);
    const index = Math.floor((percentage / 100) * (colors.length - 1));
    return colors[index];
  };
  const [_strokeColor, setStrokeColor] = useState("#07013b");
  const loadData = useCallback(async () => {
    try {
      const response = await api.get(
        `api/panel_checklist/?case_id=${caseId}&client_id=${clientId}&page_id=${page_id}&entity_id=${entity_id}`
      );
      setData(response.data?.final_checklist);
      setTopMargin(response.data?.final_checklist);
      const strokeColor2 = getColorFromPercentage(
        (response.data?.checklist_panelpercentage || 0) ?? 0
      );
      setStrokeColor(strokeColor2);
      setPercentage(response.data?.checklist_panelpercentage);
      setPanelName(response.data?.panel_name);
    } catch (error) {
      setPercentage(null);
      setData([]);
      setTopMargin(null);
      setPanelName("");
    }
  }, [caseId, clientId, page_id, entity_id]);

  // WebSocket handler for real-time panel checklist updates
  const handleWebSocketUpdate = useCallback(
    (message) => {
      if (message.type === "panel_checklist_updated" && message.data.case_id === caseId) {
        setData((prevData) => {
          // Handle null/undefined data
          if (!prevData) return prevData;

          // Update only the status of the existing item
          const updatedData = prevData.map((item) =>
            item.id === message.data.id ? { ...item, status: message.data.status } : item
          );

          // Calculate percentage from updated data
          const totalItems = updatedData.length;
          const completedItems = updatedData.filter((item) => item.status === true).length;
          const newPercentage =
            totalItems > 0 ? Math.floor((completedItems / totalItems) * 100) : 0;

          // Update other state
          setPercentage(newPercentage);
          setStrokeColor(getColorFromPercentage(newPercentage));

          // Return updated data
          return updatedData;
        });
      }
    },
    [caseId]
  );

  // Connect to WebSocket for real-time updates
  useChecklistWebSocket(caseId, handleWebSocketUpdate);

  const dropdownRef = React.useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
        setTopMarginShow(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  function getPagePanelName(page_id) {
    const page = pages?.find((p) => p?.id === page_id);
    const panel_checklist_name = page?.panel_checklist_name;
    if (panel_checklist_name) {
      const words = panel_checklist_name.split(" ");
      const lines = [];
      for (let i = 0; i < words.length; i += 2) {
        lines.push(words.slice(i, i + 2).join(" "));
      }
      return lines.map((line, i) => (
        <React.Fragment key={i}>
          {i > 0 && <br />}
          {line}
        </React.Fragment>
      ));
    }
    return "";
  }

  //U2:13AM/6/27/2024
  function dropDownBtn() {
    return (
      <button
        className="dropdown-toggle text-darker d-flex align-items-center justify-content-space-between w-100"
        id="myDropdown"
        type="button"
        onClick={() => calculateTopMargin()}
        aria-expanded="false"
        style={{ padding: show ? "0px 10px 0px 3.5px" : "0px 8.5px 0px 3px" }}
      >
        <div
          className={`nt-box ${show ? "m-l-2" : "m-l-2"} m-r-1`}
          id="ntbox-margin-20"
          style={{
            position: "relative",
            left: show ? "-0.5px" : "0px",
          }}
        >
          <CircularGauge percentage={percentage ?? 0} size={44} />
        </div>
        <span className="d-flex align-items-center justify-content-between">
          <span
            className="ic has-no-after ic-check text-success d-lg-flex d-xl-flex align-items-center justify-content-center"
            style={{ marginLeft: show ? "4px" : "" }}
          >
            {/* <img
              src={VerifiedIcon}
              alt="Verified"
              style={{
                width: "17px",
                height: "17px",
                // marginRight: "5px",
              }}
            /> */}
          </span>
          <span
            className={
              "n-mr2 ic has-no-after ic-arrow text-white d-lg-flex d-xl-flex align-items-center justify-content-center"
            }
            style={{
              right: show ? "0px" : "0px",
              // position: show ? "relative" : "",
              transform: show ? "rotate(180deg)" : "none",
              position: "relative",
              left: show ? "-3px" : "-3px",
            }}
          >
            <svg
              width="17"
              height="50"
              viewBox="0 0 17 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 16H4.59998L8.5 19.95L12.4 16H17L8.5 24.55L0 16Z"
                fill="currentColor"
                style={{
                  color: show ? "var(--primary-15)" : "var(--primary-30)",
                }}
              />
              <path
                d="M0 25.4512H4.59998L8.5 29.4012L12.4 25.4512H17L8.5 34.0012L0 25.4512Z"
                fill="currentColor"
                style={{
                  color: show ? "var(--primary-30)" : "var(--primary-15)",
                }}
              />
            </svg>
          </span>
          <span
            className="checklist-text has-column text-white c-margin-r-check"
            style={{
              right: show ? "-1.5px" : "",
              position: show ? "relative" : "",
            }}
          >
            {getPagePanelName(page_id)}
          </span>
        </span>
      </button>
    );
  }
  //U2:13AM/6/27/2024
  function dropDownChecklist() {
    return (
      <div
        aria-labelledby="myDropdown"
        // id="actionbarChecklist"
        // className="checklist-section-wrapper"
        // style={{ overflowY: "scroll", scrollbarWidth: "none" }}
      >
        <div
          className={type === "sol" ? "panel-skew-box-sol" : "panel-skew-box"}
          style={{ width: "225px" }}
        />
        <div
          className="checklist-section"
          style={{
            marginLeft: "auto",
            maxWidth: "208px",
            paddingRight: "0px",
            clipPath: "polygon(0 0, 100% 0%, 100% 100%, 4% 100%)",
            background: "transparent",
          }}
        >
          {dropDownBtn()}
        </div>
        {data &&
          data.map((element, index) => {
            return (
              <div
                className="checkbox-line p-r-5 p-l-5"
                style={{
                  marginLeft: "auto",
                  backgroundColor: `var(--primary-${index % 2 === 0 ? 4 : 10}) !important`,
                  paddingTop: "2px",
                  paddingBottom: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  maxWidth: "180px",

                  cursor: "default",
                }}
              >
                <input
                  type="checkbox"
                  checked={!!element.status}
                  disabled={!element.status}
                  // id="medicalcheck11"
                  // name="medicalcheck11"
                  readOnly
                  className="m-r-5 checkbox-line p-r-5 p-l-5"
                  style={{
                    pointerEvents: "none",
                  }}
                />
                <span
                  style={{
                    marginBottom: "0px",
                    // display: "inline",
                    color: "var(--primary)",
                    fontWeight: "400",
                  }}
                >
                  {element.name}
                </span>
                {/* <label
                  for="medicalcheck11"
                  className="mb-0"
                  style={{
                    color: "var(--primary)",
                    fontWeight: "400",
                    // whiteSpace: "nowrap",
                  }}
                >
                  {element.name}
                </label> */}
              </div>
            );
          })}
      </div>
    );
  }
  // Load initial data on mount - WebSocket keeps data fresh after that
  useEffect(() => {
    loadData();
  }, [loadData]);

  function calculateTopMargin() {
    setTopMarginShow(!show);
    setShow(!show);
  }

  return (
    <>
      {show ? (
        <div
          id="actionbarChecklist"
          className="checklist-section-wrapper"
          style={{ top: page_id === 4 ? "0" : "0px" }}
          ref={dropdownRef}
        >
          <div
            className={type === "sol" ? "panel-skew-box-sol" : "panel-skew-box"}
            style={{ width: "225px" }}
          />
          {dropDownChecklist()}
        </div>
      ) : (
        // </Modal>
        <div
          className="checklist-section-wrapper"
          ref={dropdownRef}
          style={{ top: page_id === 4 ? "0" : "0px" }}
        >
          <div
            className={type === "sol" ? "panel-skew-box-sol" : "panel-skew-box"}
            style={{ width: "225px" }}
          />
          <div className="checklist-section p-0 checklist-section-treatment-page-after">
            <div className="dropdown w-100">{dropDownBtn()}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default PanelChecklistTreatment;
